/**
 * Roulette result parser.
 * Mirrors packages/amgroulette_v2/lib/domain/game_engine/result_parser.dart:
 *   input is a comma-separated string; first element is the winning number (0..36).
 */
export interface ParsedResult {
  winningNumber: number;
}

export function parseResultString(raw: string): ParsedResult {
  const parts = raw
    .split(',')
    .map((p) => p.trim())
    .filter((p) => p.length > 0);
  if (parts.length === 0) throw new Error(`Empty result string: ${raw}`);

  const first = parts[0];
  const m = /-?\d+/.exec(first);
  if (!m) throw new Error(`Invalid winning number: ${first}`);
  const n = parseInt(m[0], 10);
  if (!Number.isFinite(n) || n < 0 || n > 36) {
    throw new Error(`Winning number out of range (0..36): ${n}`);
  }
  return { winningNumber: n };
}
